
import { useLocation } from "react-router";
import { useAppDataDispatch } from "../Context/AppDataContext";
import { useEffect } from "react";

function RouteTracker() {

    let location        = useLocation(),
        AppDataDispatch =  useAppDataDispatch();

    useEffect(() => {

        AppDataDispatch({type:'upd_route', location})
        console.log(location, "current app route");

    },[location,AppDataDispatch])
}

export default RouteTracker;